import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {raise} from '@/utilities/helpers'
import {
    httpGenerateMedicalReportPdf,
    HttpGenerateMedicalReportPdfOptions
} from '@/features/medical-reports/http/medicalReports.http'

export const useGenerateMedicalReportPdf = (
    urlParams: HttpGenerateMedicalReportPdfOptions['urlParams'],
    options?: Omit<UseMutationOptions, 'mutationFn' | 'mutationKey'>
) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.GENERATE_MEDICAL_REPORT_PDF, urlParams],
        mutationFn: () =>
            httpGenerateMedicalReportPdf({
                urlParams: {medicalReportId: urlParams?.medicalReportId || raise('medicalReportId is required')}
            })
    })
